// The app's on/off switch — one control, so every setting and every rule
// toggle looks and behaves the same. `label` is its accessible name (it has no
// visible text of its own); .settings-toggle is in the C14 hit-area list, so
// the 46×26 track still gets a 44px tap target on phones.
export default function Switch({ checked, onChange, label, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      className="settings-toggle"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: 46, height: 26, borderRadius: 13, border: 'none', cursor: disabled ? 'default' : 'pointer',
        background: checked ? 'var(--selected-solid-bg)' : 'var(--field-edge)',
        position: 'relative', transition: 'background 0.2s', flexShrink: 0,
        opacity: disabled ? 'var(--disabled-opacity)' : 1,
      }}
    >
      <span style={{
        width: 20, height: 20, borderRadius: '50%', background: '#fff',
        position: 'absolute', top: 3, left: checked ? 23 : 3,
        transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
        display: 'block',
      }} />
    </button>
  );
}
